import { useEffect, useState } from 'react';

import {
	DeleteOutlined,
	OrderedListOutlined,
	PauseCircleOutlined,
	PlayCircleOutlined,
	UnorderedListOutlined,
} from '@ant-design/icons';
import { Button, Flex, List, Popconfirm, Table, Tooltip, message } from 'antd';
import { useNavigate } from 'react-router-dom';

import { useDeleteMonitorCategory } from '@/api/monitor_collections';
import { IMonitorCategoryItem, ISingleMonitorItem } from '@/ts';

type TProps = {
	data: any;
	columns: any;
	onTableChange: any;
	isLoading?: boolean;
	isFetching?: boolean;
	pagination: any;
	setPagination: any;
	onEditCreatorClick: any;
	monitor_id: number;
};

export default function SingleMonitorCategoriesTable({
	data,
	columns,
	onTableChange,
	isLoading,
	isFetching,
	pagination,
	setPagination,
	onEditCreatorClick,
	monitor_id,
}: TProps) {
	const navigate = useNavigate();
	// const { data: collectionStoreData } = useCollectionStore();
	const [currentId, setCurrentId] = useState<number | null>(null);
	const { mutate: updateCreatorStatus, isLoading: isUpdateLoading } = {
		mutate: (x: any, y: any) => {},
		isLoading: false,
	};
	// useUpdateMonitorCreatorStatus();

	const { mutate: deleteCategory, isLoading: isDeleteLoading } =
		useDeleteMonitorCategory(monitor_id);

	const onDeleteClick = (record: any) => {
		const { category_id } = record;

		setCurrentId(category_id);

		deleteCategory(
			{
				category_id,
				monitor_id,
			},
			{
				onSuccess: () => {
					message.success('Removed');
				},
				onError: (error: any) => {
					const err = error as any;
					console.error(
						'Error removing collection:',
						err.response.data.message,
					);
					if (err?.response?.data?.message) {
						message.error(err.response.data.message);
					} else {
						message.error('An error occurred while removing the collection.');
					}
				},
			},
		);
	};

	const onViewListHistoryClick = (data: any) => {
		const { id, title } = data;

		navigate(`list-history/${id}`, {
			state: {
				monitor_id: monitor_id,
				category_id: id,
				category_title: title,
			},
			relative: 'path',
		});
	};

	return (
		<Table
			size="small"
			dataSource={data}
			columns={[
				...columns,
				{
					title: 'Actions',
					// ellipsis: true,
					width: 100,
					dataIndex: 'actions',
					key: 'actions',
					fixed: 'right',
					render: (_: any, record: ISingleMonitorItem) => {
						return (
							<Flex justify="center" align="center" style={{ gap: '4px' }}>
								<Tooltip title="View history" placement="left">
									<Button
										style={{
											padding: '5px',
											height: '28px',
											fontSize: '16px',
											color: 'gray',
										}}
										disabled={isDeleteLoading}
										onClick={() =>
											onViewListHistoryClick({
												id: record?.monitor_list_id,
												title: record?.name,
											})
										}
									>
										<UnorderedListOutlined />
									</Button>
								</Tooltip>
								<Popconfirm
									title={`Sure to remove category?`}
									onConfirm={() => onDeleteClick(record)}
									placement="topLeft"
								>
									<Tooltip title="Remove category" placement="left">
										<Button
											style={{
												padding: '5px',
												height: '28px',
												fontSize: '16px',
												color: 'gray',
											}}
											loading={
												isDeleteLoading && currentId === record?.category_id
											}
											disabled={isDeleteLoading}
											// danger
										>
											<DeleteOutlined />
										</Button>
									</Tooltip>
								</Popconfirm>
							</Flex>
						);
					},
				},
			]}
			style={{ width: '100%' }}
			// scroll={{ x: 500 }}
			rowClassName="editable-row"
			rowKey={'category_id'}
			onChange={onTableChange}
			loading={isLoading || isFetching || isUpdateLoading || isDeleteLoading}
			bordered
			pagination={{
				total: pagination?.total,
				showSizeChanger: true,
				current: pagination?.page,
				pageSizeOptions: [10, 25, 50],
				onChange: (page: number, pageSize: number) => {
					setPagination((cur: any) => ({ ...cur, page, limit: pageSize }));
				},
			}}
		/>
	);
}
